import { ButtonSize, ButtonVariant, PrimaryButton } from '@uni-of-exeter/digital.lib.react.ui.kit';

import './feedback-block.css';
import { APP_TEXT } from '../const/app-text';

const pageText = APP_TEXT.pages.dashboard;

export default function FeedbackBlock() {
  return (
    <div className="leaveFeedbackBlockBg">
      <div className="leaveFeedbackBlock">
        <p>{pageText.footer.leaveFeedback}</p>

        <PrimaryButton
          variant={ButtonVariant.Outline}
          aria-label={pageText.footer.leaveFeedbackButton}
          buttonSize={ButtonSize.Medium}
          onClick={() => {
            window.open(pageText.feedbackForm, '_blank');
          }}
        >
          {pageText.footer.leaveFeedbackButton}
        </PrimaryButton>
      </div>
    </div>
  );
}
